<template lang="pug">
.order-list-item
  .header(v-if="isHeader")
    .row-6
      .row-3 商品
      .row-2 商品属性
      .row-2 价格
      .row-1 数量
      .row-2 重量
    .row-1 售后
    .row-2 订单金额
    .row-2 买家信息
    .row-1 状态
    //- .row-1 操作

  .title.mb-5
    .left
      span 订单编号：
      span.order-num {{bizOrder.bizOrderId}}
      span.ml-20 下单时间：
      time {{bizOrder.createTime | dataFormat}}
      span.ml-20 发货方式：
      span {{ bizOrder.logisticsWay | getLogisticsWayChn }}
      span.ml-20(v-if="orderInfo.closeReason") 取消原因：
      span(v-if="orderInfo.closeReason") {{orderInfo.closeReason}}

      el-tag.m-l10.tag(v-if="bizOrder.subBizType === 100"
        effect="plain" size="small") 工程
      el-tag.m-l10.tag(v-if="bizOrder.subBizType === 100 && bizOrder.finacedAmount > 0"
        effect="plain" size="small" type="danger") 融资
      el-tag.m-l10.tag(v-if="bizOrder.subBizType === 200"
        effect="plain" size="small" type="warning") 不定规格
      el-tag.m-t10.m-l10.tag(v-if="orderInfo.bizOrder && (orderInfo.bizOrder.futuresFlag || orderInfo.bizOrder.containerFuturesGoods)"
        effect="plain" size="small" type="warning") 预售
      //el-tag.m-l10.tag(v-if="bizOrder.subBizType === 100" effect="plain" size="small" type="warning") 先货后款

    //- span.ml-20(v-if="!bizOrder.futuresFlag && orderInfo.bizOrderPayTimeOut > 0 && bizOrder.orderStatus === 'WAITING_PAY'") 剩余支付时间：
    //- countdown(:end-time="Date.now() + orderInfo.bizOrderPayTimeOut * 1000" @onTimeEnd="$emit('onTimeEnd', orderInfo)"
    //-   v-if="!bizOrder.futuresFlag && orderInfo.bizOrderPayTimeOut > 0 && bizOrder.orderStatus === 'WAITING_PAY'")
  .title.mt--20.mb-5
    span.key 买家备注：
    span.line-1 {{orderInfo.otherInfo || '无'}}
  .title.mt--20
    span.key 卖家备注：
    span.line-1 {{orderInfo.sellerMemo || '无'}}
  .order
    ul.sku.row-6
      li(v-for="item, index in orderList" :key="index")
        .info.row-3
          p.goods-name {{item.itemTitle}}
          p.goods-no 商品编号：{{item.itemId}}
          p.goods-no(v-if="item.supplierName") {{ item.supplierName }}
          el-tag.m-t10.tag(v-if="item.bizOrder.containerFuturesGoods"
            effect="plain" size="small" type="warning") 预售
        .row-2
          .text-l.goods-value(style="width: 160px")
            p.flex(v-for="item, index in item.skuTitleList" :key="index")
              span {{item.split(':')[0]}}:
              span.c-3(v-if="item.length < 14") {{item.split(':')[1] || '-'}}
              el-tooltip.max-len(v-else placement="top" :content="item.split(':')[1]")
                span {{item.split(':')[1] || '-'}}
            p(v-if="item.warehouseName") 仓库: {{item.warehouseName}}
        .row-2
          template
            .cell
              span(v-if='item.bizOrder.logisticsPrice || item.bizOrder.processFee || item.bizOrder.storageFee || item.bizOrder.commissionFee || item.bizOrder.promiseInterestSubsidyFee || item.bizOrder.settleAdjustFee') {{ (item.itemPrice + item.bizOrder.logisticsPrice + item.bizOrder.processFee + item.bizOrder.storageFee + item.bizOrder.commissionFee + item.bizOrder.promiseInterestSubsidyFee + item.bizOrder.settleAdjustFee) / 100 }} 元/{{ item.bizOrder.pieceWeightUnit | exUnitToBaseUnit }}
              span(v-else) {{ item.itemPrice / 100 }} 元/{{ item.bizOrder.pieceWeightUnit | exUnitToBaseUnit }}
              zg-info(v-if='item.bizOrder.logisticsPrice || item.bizOrder.processFee || item.bizOrder.storageFee || item.bizOrder.commissionFee || item.bizOrder.promiseInterestSubsidyFee || item.bizOrder.settleAdjustFee') {{ (item.itemPrice + item.bizOrder.logisticsPrice + item.bizOrder.processFee + item.bizOrder.storageFee + item.bizOrder.commissionFee + item.bizOrder.promiseInterestSubsidyFee + item.bizOrder.settleAdjustFee) / 100 }} 元/{{ item.bizOrder.pieceWeightUnit | exUnitToBaseUnit }}
                  div(slot="content")
                    div(v-if='item.itemPrice') 商品价格：{{ item.itemPrice / 100 }} 元/{{ item.bizOrder.pieceWeightUnit | exUnitToBaseUnit }}
                    div(v-if='item.bizOrder.logisticsPrice') 胖猫物流费：{{ item.bizOrder.logisticsPrice / 100 }} 元/{{ item.bizOrder.pieceWeightUnit | exUnitToBaseUnit }}
                    div(v-if='item.bizOrder.processFee') 加工费：{{ item.bizOrder.processFee / 100 }} 元/{{ item.bizOrder.pieceWeightUnit | exUnitToBaseUnit }}
                    div(v-if='item.bizOrder.storageFee') 仓储费：{{ item.bizOrder.storageFee / 100 }} 元/{{ item.bizOrder.pieceWeightUnit | exUnitToBaseUnit }}
                    div(v-if='item.bizOrder.commissionFee') 委托物流费：{{ item.bizOrder.commissionFee / 100 }} 元/{{ item.bizOrder.pieceWeightUnit | exUnitToBaseUnit }}
                    div(v-if='item.bizOrder.promiseInterestSubsidyFee') 承兑贴息费：{{ item.bizOrder.promiseInterestSubsidyFee / 100 }} 元/{{ item.bizOrder.pieceWeightUnit | exUnitToBaseUnit }}
                    div(v-if='item.bizOrder.settleAdjustFee') 结算调差费：{{ item.bizOrder.settleAdjustFee / 100 }} 元/{{ item.bizOrder.pieceWeightUnit | exUnitToBaseUnit }}
        .row-1
          .cell {{item.buyAmount}}
        .row-2
          .cell {{(parseInt(item.bizOrder.totalWeight) / 10000)}}
            | {{ item.bizOrder.pieceWeightUnit | exUnitToWeight }}
    .row-1
      .cell(:class="{'cell-top-30': orderList.length > 1}")
        | {{ orderInfo.existRefundApply ? '发起过售后' : '未发起售后' }}

    .receiv.row-2
      template
        .cell(:class="{'cell-top-30': orderList.length > 1}")
          | {{ bizOrder.actualTotalFee | currencyFormat }}
          zg-info(v-if='bizOrder.logisticsTotalFee || bizOrder.processTotalFee || bizOrder.storageTotalFee || bizOrder.commissionTotalFee || bizOrder.promiseInterestSubsidyTotalFee || bizOrder.settleAdjustTotalFee')
            div(slot="content")
              div 商品金额：{{ bizOrder.obligationTotalFee | currencyFormat }}
              div(v-if='bizOrder.logisticsTotalFee') 胖猫物流费金额：{{ bizOrder.logisticsTotalFee | currencyFormat }}
              div(v-if='bizOrder.processTotalFee') 加工费金额：{{ bizOrder.processTotalFee | currencyFormat }}
              div(v-if='bizOrder.storageTotalFee') 仓储费金额：{{ bizOrder.storageTotalFee | currencyFormat }}
              div(v-if='bizOrder.commissionTotalFee') 委托物流费金额：{{ bizOrder.commissionTotalFee | currencyFormat }}
              div(v-if='bizOrder.promiseInterestSubsidyTotalFee') 承兑贴息金额：{{ bizOrder.promiseInterestSubsidyTotalFee | currencyFormat }}
              div(v-if='bizOrder.settleAdjustTotalFee') 结算调差金额：{{ bizOrder.settleAdjustTotalFee | currencyFormat }}

      //- template(v-else)
      //-   .cell(:class="{'cell-top-30': orderList.length > 1}") {{ orderInfo.totalFee | currencyFormat }}

    .seller.row-2
      .cell.p-0-10(:class="{'cell-top-10': orderList.length > 1}")
        .company {{bizOrder.buyerOrgName}}
        .name
          span {{bizOrder.buyerNick}}
          svg-icon.chat(icon-class="im-icon" @click="toChat(bizOrder.buyerId)" v-if="bizOrder.buyerId")
        .phone {{bizOrder.buyerPhone | phoneFormat}}

    .status.row-1
      .cell(:class="{'cell-top-30': orderList.length > 1}")
        span {{bizOrder.orderStatus | orderStatusFormat}}
        el-button.btn-text.m-t10(type="text" @click="$router.push(`detail/${bizOrder.bizOrderId}`)") 查看详情

    //- .operate.row-1
    //-   .cell(:class="{'cell-top-25': orderList.length > 1}")
    //-     el-button.btn-text(type="text" @click="isShowSellerMemo = true") 添加备注
    //-     el-button.btn-text(type="text" @click="updatePrice" v-if="bizOrder.orderStatus === 'WAITING_PAY'") 修改价格
    //-     el-button.btn-text(type="text" @click="updateTime" v-if="bizOrder.orderStatus === 'WAITING_PAY'") 延长付款
        //- .sign-container(v-if="!['CLOSED', 'CANCEL'].includes(bizOrder.orderStatus) && [CONTRACT_STATUS.INIT.key, CONTRACT_STATUS.SELLER_UNSIGNED.key].includes(item.detailStatus) && !item.orgInfo.isSelfOrg && bizOrder.createTime > 1577379600000 && bizOrder.subBizType !== 100")
          //- img(src="~@/assets/inviteSign.png" class="sign-tip" v-if="showSignTip" @click="$emit('close-tip')")
          //- el-button.btn-text(type="text" @click="goToSign" ) 去签约

  el-dialog(:visible.sync="isShowSellerMemo" title="添加备注" center)
    el-input(type="textarea" :rows="5" maxlength="50" placeholder="可以输入50个字的备注"
      v-model="remark" show-word-limit)
    .hint 该备注仅自己可见
    .dialog-footer(slot="footer")
      el-button(@click="isShowSellerMemo = false") 取 消
      el-button(type="primary" @click="confirmSellerMemo") 确 认

</template>

<script>
import Countdown from './countdown'
import ZgInfo from '@/components/zg-info'
import { CONTRACT_STATUS } from '@/common/constants/index'
export default {
  props: {
    isHeader: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showSignTip: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Countdown,
    ZgInfo
  },
  data() {
    return {
      orderInfo: {} /** 交易订单基础信息 */,
      bizOrder: {} /** 交易订单基础信息 */,
      shopInfo: {} /** 交易订单基础信息 */,
      orderList: [] /** 交易订单基础信息 */,
      isShowSellerMemo: false,
      remark: '',
      CONTRACT_STATUS
    }
  },
  mounted() {
    const { item } = this
    if (item) {
      const { bizOrder, shopInfo, detailOrders, sellerMemo = '' } = item
      this.orderInfo = item
      this.bizOrder = bizOrder
      this.shopInfo = shopInfo
      this.remark = sellerMemo
      this.orderList = (detailOrders || []).map(o => {
        o.skuTitleList = JSON.parse(o.skuTitleListJson || '[]')
        return o
      })
    }
  },
  methods: {
    // getWeightUnit(type) {
    //   let out = '吨'
    //   if (type === 'KG') {
    //     out = '千克'
    //   }
    //   return out
    // },
    updatePrice() {
      this.$emit('updatePrice', this.item)
    },
    updateTime() {
      this.$emit('updateTime', this.item)
    },
    toChat(id) {
      console.log(id)
      window.IM &&
        window.IM.show({
          sessionId: id
        })
    },
    /** 确认添加订单备注 */
    async confirmSellerMemo() {
      try {
        const result = await this.$post('trademanager.createOrderRemarkForSeller', {
          bizOrderId: this.bizOrder.bizOrderId,
          remark: this.remark
        })
        if (result.success) {
          if (result.data[0].value) {
            this.$message.success('添加订单备注成功')
            this.isShowSellerMemo = false
            this.orderInfo.sellerMemo = this.remark
          } else {
            this.$message.error('添加订单备注失败')
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    async goToSign() {
      let { contractNo, contractVersion } = this.item
      let param = {
        contractNo,
        contractVersion,
        source: 1,
        returnUrl: window.location.href,
        expireTime: 604800 // 七天
      }
      let { success, data } = await this.$post('contract.sign', { request: param })
      if (success) {
        window.location.href = data[0].url
      } else {
        switch (data.stat.stateList[0].code) {
          case 5015:
            this.openVerify(1)
            return false
          case 5014:
            this.openVerify(2)
            return false
          case 5017:
            this.openVerify()
            return false
          case 5007:
            this.$alert('合同正在生成中，请稍后再试。', '提示', {
              confirmButtonText: '确定',
              callback: () => {
                this.getOrderDetail()
              }
            })
            return false
          default:
            this.$message.warning('请稍候再试或者联系管理员')
        }
      }
    },
    openVerify(range = 0) {
      this.$emit('open-verify', range)
    }
  }
}
</script>

<style lang="stylus" scoped>
.order-list-item
  font-size 13px
  color #666
  margin-bottom 20px

.header
  display flex
  text-align center
  background rgba(248,248,248,1)
  height 40px
  line-height 40px
  font-size 12px
  color #999999
  margin-bottom 20px
  .row-6
    display flex
  div
    border none

.title
  background-color rgba(248,248,248,1)
  padding 10px 20px
  color #666
  font-size 12px
  display flex
  align-items center

  .left
    flex 1

  .line-1
    flex 1
    display inline-block
    white-space nowrap
    width 100%
    overflow hidden
    text-overflow ellipsis

  .key
    width 60px

  .ml-20
    margin-left 20px

  .tag
    border-radius:unset
    height:17px
    line-height:12px
    padding:2px
.row-1
  flex 1
  height auto
  min-height 75px
  position relative
  border-left 1px solid rgba(240,240,240,1)
  border-bottom 1px solid rgba(240,240,240,1)

.row-2
  flex 2
  height auto
  position relative
  border-left 1px solid rgba(240,240,240,1)
  border-bottom 1px solid rgba(240,240,240,1)

.row-3
  flex 3
  height auto
  position relative

.row-6
  flex 6
  height auto
  position relative

.order
  display flex
  align-items stretch
  text-align center
  border-top 1px solid rgba(240,240,240,1)
  border-right 1px solid rgba(240,240,240,1)

  .cell
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    width 100%
    white-space normal
    word-break break-all
    word-wrap break-word

  .goods-value
    padding 15px 0
    p
      font-size 12px
      padding 0 5px
      margin-bottom 3px

  .cell-top-10
    top 10px
    left 50%
    transform translateX(-50%)

  .cell-top-30
    top 30px
    left 50%
    transform translateX(-50%)

  .cell-top-25
    top 25px
    left 50%
    transform translateX(-50%)


  .p-0-10
    padding 0 10px

  .sku
    li
      display flex
      align-items stretch

    .info
      border-left 0
      text-align left
      line-height 1.4
      padding 10px
      border-left 1px solid rgba(240,240,240,1)
      border-bottom 1px solid rgba(240,240,240,1)

    .goods-name
      font-size 14px
      color #333
      line-height 1.4
      width 100%
      white-space normal
      word-wrap break-word
      word-break break-all
      overflow hidden
      text-overflow ellipsis
      display -webkit-box
      -webkit-line-clamp 2
      -webkit-box-orient vertical

    .goods-no
      font-size 12px
      color #999

  .receiv
    color #cd974c
    font-size 14px

  .seller
    line-height 1.4
    text-align left

    .company
      color #000
      font-size 14px
      width 100%
      white-space nowrap
      text-overflow ellipsis
      overflow hidden
      word-break break-all

    .name, .phone
      color #333

  .btn-text
    padding 2px 8px !important
    font-size 12px
    margin-left 0

.status
  color #cd974c

.text-l
  text-align left

.chat
  margin-left 6px
  font-size 15px
  vertical-align middle
  cursor pointer
.mt--20
  margin-top -20px
.mb-5
  margin-bottom 5px
.sign-container
  position relative
  .sign-tip
    width 106px
    height 62px
    position absolute
    left -15px
    top 18px
    z-index 10
.hint
  margin-top 10px
  color #999
  font-size 14px
.wide-tip
  width 100px
.max-len
  display inline-block
  width 80px
  overflow hidden
  text-overflow ellipsis
  white-space nowrap
</style>
